import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

// Thunks for speciality actions

export const add_speciality = createAsyncThunk(
  "speciality/add_speciality",
  async (speciality, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/speciality-add", speciality, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_specialitys = createAsyncThunk(
  "speciality/get_specialitys",
  async ({ page, parPage, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/speciality-gets?page=${page}&pagSize=${parPage}&searchValue=${searchValue}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_speciality = createAsyncThunk(
  "speciality/get_speciality",
  async (specialityId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/speciality-single/${specialityId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const update_speciality = createAsyncThunk(
  "speciality/update_speciality",
  async (obj, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`/speciality-update`, obj, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_speciality = createAsyncThunk(
  "speciality/delete_speciality",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.delete(`/speciality/${id}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

const specialitySlice = createSlice({
  name: "speciality",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    specialities: [],
    specialityData: null,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // Add speciality
      .addCase(add_speciality.pending, (state) => {
        state.loader = true;
      })
      .addCase(add_speciality.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.specialities.push(payload.speciality);
      })
      .addCase(add_speciality.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      // Get all specialities
      .addCase(get_specialitys.pending, (state) => {
        state.loader = true;
      })
      .addCase(get_specialitys.fulfilled, (state, { payload }) => {
        state.loader = false;
      
        state.specialities = payload.specialityData;
      })
      .addCase(get_specialitys.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload?.error || payload;
      })

      // Get a single speciality
      .addCase(get_speciality.pending, (state) => {
        state.loader = true;
      })
      .addCase(get_speciality.fulfilled, (state, { payload }) => {
        state.loader = false;
    
        state.specialityData = payload.specialitys || null;
      })
      .addCase(get_speciality.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      // Update speciality
      .addCase(update_speciality.pending, (state) => {
        state.loader = true;
      })
      .addCase(update_speciality.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.specialityDetails = payload.speciality || null;
      })
      .addCase(update_speciality.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      })

      // Delete speciality
      .addCase(delete_speciality.pending, (state) => {
        state.loader = true;
      })
      .addCase(delete_speciality.fulfilled, (state, { payload }) => {
        state.loader = false;
        state.successMessage = payload.message;
        state.specialities = state.specialities.filter(
          (speciality) => speciality._id !== payload.specialityId
        );
      })
      .addCase(delete_speciality.rejected, (state, { payload }) => {
        state.loader = false;
        state.errorMessage = payload.error;
      });
  },
});

export const { messageClear } = specialitySlice.actions;
export default specialitySlice.reducer;
